var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("KTextbox", {
    ref: "textbox",
    attrs: {
      value: _vm.value,
      disabled: _vm.$attrs.disabled,
      label: _vm.coreString("usernameLabel"),
      autofocus: _vm.$attrs.autofocus,
      maxlength: 30,
      invalid: Boolean(_vm.shownInvalidText),
      invalidText: _vm.shownInvalidText,
      autocomplete: "username",
    },
    on: {
      blur: function ($event) {
        _vm.blurred = true
      },
      input: _vm.handleInput,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }